import React, { useState, useEffect } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import RedditPost from './components/RedditPost/RedditPost';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { getPosts } from './api/reddit';
import Home from './components/Home/Home';
import Favorites from './components/Favorites/Favorites';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Icon from '@material-ui/core/Icon';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#ff80b3',
        },
    },
    overrides: {
        MuiToolbar: {
            root: {
                color: 'white',
            },
        },
        MuiAppBar: {
            root: {
                height: '64px',
            },
        },
        MuiBottomNavigation: {
            root: {
                height: '56px',
            },
        },
    },
});

const INDEX = '/';
const FAVORITES = '/favorites';

function App() {
    const [data, setData] = useState({ posts: [], after: null });

    const loadMore = async () => {
        let response = await getPosts(data.after);

        // Already existing posts might appear again. Skip them.
        const ids = new Set(data.posts.map((post) => post.id));
        const newPosts = [...data.posts];

        for (const post of response.posts) {
            if (!ids.has(post.id)) {
                newPosts.push(post);
                ids.add(post.id);
            }
        }

        setData({ posts: newPosts, after: response.after });
    };

    const [favorites, setFavorites] = useState(getInitialFavorites());

    const addToFavorites = (postId) => {
        const newFavorites = [...favorites, postId];
        window.localStorage.setItem('favorites', JSON.stringify(newFavorites));
        setFavorites(newFavorites);
    };

    const removeFromFavorites = (postId) => {
        const newFavorites = favorites.filter((id) => id !== postId);
        window.localStorage.setItem('favorites', JSON.stringify(newFavorites));
        setFavorites(newFavorites);
    };

    const location = useLocation();
    const history = useHistory();

    const [bottomNavSelection, setBottomNavSelection] = useState(0);

    useEffect(() => {
        if (location.pathname === INDEX) {
            setBottomNavSelection(0);
        } else if (location.pathname === FAVORITES) {
            setBottomNavSelection(1);
        }
    }, [location.pathname]);

    return (
        <MuiThemeProvider theme={theme}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: `calc(100% - ${theme.overrides.MuiBottomNavigation.root.height})`,
                }}
            >
                <Switch>
                    <Route
                        exact
                        path={INDEX}
                        render={(props) => (
                            <Home
                                {...props}
                                posts={data.posts}
                                loadMore={loadMore}
                            />
                        )}
                    />
                    <Route
                        path={FAVORITES}
                        render={(props) => (
                            <Favorites {...props} favorites={favorites} />
                        )}
                    />
                    <Route
                        path="/posts/:postId"
                        render={(props) => (
                            <RedditPost
                                {...props}
                                favorites={favorites}
                                addToFavorites={addToFavorites}
                                removeFromFavorites={removeFromFavorites}
                            />
                        )}
                    />
                </Switch>
                <BottomNavigation
                    style={{
                        display: 'flex',
                        position: 'fixed',
                        bottom: 0,
                        width: '100%',
                    }}
                    value={bottomNavSelection}
                    onChange={(_event, newValue) => {
                        if (newValue === 0) {
                            history.replace(INDEX);
                        } else {
                            if (location.pathname === INDEX) {
                                history.push(FAVORITES);
                            } else {
                                history.replace(FAVORITES);
                            }
                        }
                    }}
                    showLabels
                >
                    <BottomNavigationAction
                        label="Home"
                        icon={<Icon>home</Icon>}
                    />
                    <BottomNavigationAction
                        label="Favorites"
                        icon={<Icon>favorite</Icon>}
                    />
                </BottomNavigation>
            </div>
        </MuiThemeProvider>
    );
}

function getInitialFavorites() {
    let initial = window.localStorage.getItem('favorites');
    if (initial) {
        return JSON.parse(initial);
    } else {
        return [];
    }
}

export default App;
